import "./TheBTStory.module.css";
import Header from "@/reusable_sections/Header";
import KompaniyaHaqida from "./sections/KompaniyaHaqida";
import OurExpertTeam from "./sections/OurExpertTeam";
import WhyTravelersChooseUs from "./sections/WhyTravelersChooseUs";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function TheBTStoryPage() {
  return <div>
      <Header />
      <KompaniyaHaqida />
      <OurExpertTeam />
      <WhyTravelersChooseUs />
      <GamingSocialFooter />
    </div>;
}